// extracted by mini-css-extract-plugin
module.exports = {"root":"Activity_root__3VoZ4","top":"Activity_top__DBRTn","split":"Activity_split__3ITmP","left":"Activity_left__3s4GI","right":"Activity_right__2UgEc","row":"Activity_row__5tGio"};